export enum WsAssetParentTypeEnum {
  TYPE_WS_MEMBER = "ws_member",
  TYPE_WS_TASK = "ws_task",
  TYPE_WS_TASK_COMMENT = "ws_task_comment",
  TYPE_WS_PROJECT = "ws_project",
  TYPE_WS_PROJECT_META_FIELD = "ws_project_meta_field",
  TYPE_WS_TASK_META_FIELD = "ws_task_meta_field",
  TYPE_WS_GLOBAL_TASK = "ws_global_task",
  TYPE_WS_GLOBAL_TASK_META_FIELD = "ws_global_task_meta_field",
  TYPE_WS_CONTENT_PROPOSAL_ELEMENT = "ws_content_proposal_element",
  TYPE_WS_DICTIONARY_META_FIELD = "ws_dictionary_meta_field",
  TYPE_WS_SOCIAL_PROFILE = "ws_social_profile",
  TYPE_TEMP = "_temp",
}
